import http from "../plugins/axios";
import { AxiosError } from "axios";
import { COSCredentials } from "../cos/credentials";

export interface checkIDForm {
  idType: string;
  region: string;
  idNumber: string;
  telNumber: string;
  realName: string;
}
export interface PublicUserInfo {
  id: number;
}
export interface PublicProfile extends PublicUserInfo {
  name: string;
}
export type AvatarCredentials = COSCredentials;
export type IdVerifyType = "null" | "pass" | "waiting" | "fail";
export interface LoginForm {
  email: string;
  password: string;
  reCaptcha: string;
}
export interface LoginOauthForm {
  code: string;
}
export interface UpdateProfileForm {
  slogan?: string;
  birthday?: number;
  gender?: string;
  degree?: string;
  province?: string;
  schoolName?: string;
  endSchoolYear?: number;
}
export interface UpdatePasswordForm {
  oldPassword: string;
  password: string;
}

export interface SelfProfile {
  nickname: string;
  slogan: string;
  telNumber: string;
  birthday: Date;
  idType: number;
  realname: string;
  idNumber: string;
  region: string;
  gender: string;
  degree: string;
  province: string;
  schoolName: string;
  endSchoolYear: number;
}
export interface RegisterForm {
  name: string;
  email: string;
  password: string;
  reCaptcha: string;
}
interface LoginResponse {
  token: string;
}

export function loginApi(form: LoginForm): Promise<string> {
  return new Promise((resolve, reject) => {
    http
      .post("/api/user/login", form)
      .then((response) => {
        return resolve((response.data as LoginResponse).token);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403 || status === 401)
            return reject("form-not-accept");
          if (status === 405) return reject("user-blocked");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}



export function refreshAPI(token: string): Promise<string> {
  return new Promise((resolve, reject) => {
    http
      .get("/api/user/refreshoauth", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        resolve((response.data as LoginResponse).token);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("form-not-accept");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function registryAction(form: RegisterForm): Promise<string> {
  return new Promise((resolve, reject) => {
    http
      .post("/api/user", form)
      .then((response) => {
        return resolve((response.data as LoginResponse).token);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 409) return reject("email-in-use");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else if (status === 410) return reject("format-error");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function refreshAPI_OLD(token: string): Promise<string> {
  return new Promise((resolve, reject) => {
    http
      .get("/api/user/refresh", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        resolve((response.data as LoginResponse).token);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("form-not-accept");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function verifyEmailAPI(
  token: string,
  email: string,
  emailId: string
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .patch(
        "/api/user",
        { email, emailId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("form-not-accept");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function resendEmailAPI(token: string): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .post(
        "/api/user/resend",
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("form-not-accept");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function resetEmailAPI(token: string, newEmail: string): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .post(
        "/api/user/resetemail",
        {
          newEmail: newEmail,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("form-not-accept");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function getSelfProfile(token: string): Promise<SelfProfile> {
  return new Promise((resolve, reject) => {
    http
      .get("/api/profile", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as SelfProfile);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 409) return reject("email-in-use");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function getProfile(token: string, memberId: number): Promise<PublicProfile> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/profile/${memberId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as PublicProfile);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 409) return reject("email-in-use");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function updatePassword(
  token: string,
  form: UpdatePasswordForm
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .put("/api/user", form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 404) return reject("unknown-page");
          else if (status === 401) return reject("token-invalid");
          else if (status === 403) return reject("password-incorrect");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function updateProfile(
  token: string,
  updateData: UpdateProfileForm
): Promise<void> {
  return new Promise((resolve, reject) => {
    http
      .put(
        "/api/profile",
        { updateData },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        return resolve();
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 403) return reject("password-incorrect");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function getAvatarToken(token: string): Promise<AvatarCredentials> {
  return new Promise((resolve, reject) => {
    http
      .get("/api/user/avatar/token", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data as AvatarCredentials);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 403) return reject("password-incorrect");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function verifyIdAPI(token: string, form: checkIDForm): Promise<number> {
  return new Promise((resolve, reject) => {
    http
      .post("/api/user/id", form, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        resolve(0);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("email-first");
          if (status === 405) return reject("id-in-use");
          if (status === 418)
            return resolve(error.response.data.failtimes as number);
          else if (status === 409) return reject("please wait");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function forgetPass(email: string): Promise<number> {
  return new Promise((resolve, reject) => {
    http
      .post(
        "/api/user/reset",
        {
          email: email,
        },
        {
          headers: {},
        }
      )
      .then(() => {
        resolve(0);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 403) return reject("email-first");
          if (status === 405) return reject("id-in-use");
          if (status === 418)
            return resolve(error.response.data.failtimes as number);
          else if (status === 409) return reject("please wait");
          else if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
